import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { io } from "socket.io-client";
import { http } from "../api/http";
import { useAuthStore } from "../store/auth.store";
export function useMessagingLive() {
  const token = useAuthStore((s) => s.token),
    qc = useQueryClient();
  useEffect(() => {
    if (!token) return;
    const base = new URL(
      http.defaults.baseURL || "/api",
      window.location.origin,
    );
    const socket = io(base.origin + "/messaging", {
      transports: ["websocket"],
      auth: { token },
      reconnectionDelay: 1000,
      reconnectionDelayMax: 10000,
    });
    const refresh = () => {
      for (const key of ["messaging-list", "messages", "messaging-directory"])
        void qc.invalidateQueries({ queryKey: [key] });
    };
    socket.on("messaging:changed", refresh);
    socket.on("messaging:revoked", () => {
      for (const key of ["messaging-list", "messages", "messaging-directory"])
        qc.removeQueries({ queryKey: [key] });
      refresh();
    });
    socket.on("connect_error", () => {
      /* HTTP polling remains authoritative. */
    });
    return () => {
      socket.disconnect();
    };
  }, [token, qc]);
}
